import { Breadcrumbs, Typography, Stack, TablePagination, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { Header } from "./components/header";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { GenerateManutencaoGerenciarColumnDefinition } from "./columns";
import { useManutencaoGerenciarListaViewModel } from "../../viewModels/manutencao_gerenciar_lista_view_model";

export const ManutencaoGerenciarLista = () => {
  const viewModel = useManutencaoGerenciarListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateManutencaoGerenciarColumnDefinition({
      onActionEditar: viewModel.handleEdit,
      onActionExcluir: viewModel.handleDeleteOpenState,
    });
  }, [
    viewModel.handleEdit,
    viewModel.handleDeleteOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              {/* <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={viewModel.handleCreate}
              >
                Novo Item
              </PrimaryButton> */}
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-6 flex-col md:p-10 px-4 pt-8 mb-12">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit">
            Controle de Patrimônio
          </Link>
          <Typography className="text-primary-green">Gerenciamento de Manutenção</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Gerenciamento de Manutenção</h1>
          <RefreshButton onClick={() => viewModel.handleClear()} />
        </div>

        <Header
          ddlFornecedores={viewModel.ddlFornecedor}
          ddlFuncionarios={viewModel.ddlFuncionario}
          ddlMaquinaEquip={viewModel.ddlMaquinaEquip}
          ddlCentroCusto={viewModel.ddlCentroCusto}
          nroManutencao={viewModel.filters.nroManutencao}
          idsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
          idsFuncionarioAprovacao={viewModel.filters.idsFuncionarioAprovacao ?? []}
          idsFuncionarioSolicitante={viewModel.filters.idsFuncionarioSolicitante ?? []}
          idsFornecedorResponsavel={viewModel.filters.idsFornecedorResponsavel ?? []}
          idsMaquinaEquip={viewModel.filters.idsMaquinaEquip ?? []}
          dataDe={viewModel.filters.dataSolicitacaoDe}
          dataAte={viewModel.filters.dataSolicitacaoAte}
          status={viewModel.filters.status ?? []}
          onFuncionarioAprovacaoChange={viewModel.handleFuncionarioAprovacaoChange}
          onFuncionarioSolicitanteChange={viewModel.handleFuncionarioSolicitanteChange}
          onFornecedorResponsavelChange={viewModel.handleFornecedorChange}
          onMaquinaEquipChange={viewModel.handleMaquinaEquipChange}
          onIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
          onNroManutencaoChange={viewModel.handleNroManutencaoChange}
          onDataChange={viewModel.handleDataChange}
          onStatusChange={viewModel.handleStatusChange}
          onClearFilters={viewModel.handleClear}
        />

        <Stack spacing={0}>
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

          <StyledDataGrid
            tableName="ProjetoRevisao"
            disableColumnMenu={false}
            showToolbar
            disableRowSelectionOnClick
            getRowId={(row: any) => row.idManutencao}
            columns={columnsDefinition}
            loading={viewModel.loading}
            rows={viewModel.listaManutencao ?? []}
            rowCount={viewModel.pagination.totalItems}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page - 1,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ['idManutencao'],
            }}
            getRowHeight={() => 'auto'}
            textSize="muitoPequeno"
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

        </Stack>
      </div>

      <DeleteDialog
        open={viewModel.openDelecaoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteOpenState(null, false)}
        title={`Você realmente deseja excluir esta manutenção?`}
        onDelete={viewModel.handleDeleteConfirm}

      />
    </>

  );
};
